import truncate from "./truncate/index";
import formatDate from "./format-date/index";
export default {
  install(app) {
    app.directive("truncate", truncate);
    app.directive("format-date", formatDate);
  },
};
